import validateMany from 'services/redux-form/validateMany';
import regex from 'services/regex';
import store from 'store';

const validate = (values, props) => {

};

export default validate;
